import { Dialog, DialogContent, DialogTitle } from 'components/ui/dialog';
import { useState } from 'react';

export interface ValuePreview {
    title: string;
    content: string;
}

export function ValuePreviewDialog({ preview, onClose }: { preview: ValuePreview | null; onClose: () => void }) {
    // Retain the last non-null preview so the content doesn't blank out while
    // the dialog is still playing its close animation.
    const [retained, setRetained] = useState(preview);
    if (preview !== null && preview !== retained) {
        setRetained(preview);
    }
    const displayed = preview ?? retained;

    return (
        <Dialog open={preview !== null} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="max-w-[calc(100%-2rem)] gap-0 rounded-[14px] p-0 sm:max-w-[640px]">
                <div className="border-grey-200 flex items-center justify-between border-b py-4 pr-14 pl-5">
                    <DialogTitle className="text-fg text-[15px] font-semibold">{displayed?.title}</DialogTitle>
                </div>
                <div className="bg-grey-50 max-h-[70dvh] overflow-auto px-5 py-[18px]">
                    <pre className="text-fg font-mono text-[12.5px] leading-[1.7] break-words whitespace-pre-wrap">
                        {displayed?.content}
                    </pre>
                </div>
            </DialogContent>
        </Dialog>
    );
}
